// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ITaxYearContributionDetailsDto
 */
export interface ITaxYearContributionDetailsDto {
    /**
     * 
     * @type {string}
     * @memberof ITaxYearContributionDetailsDto
     */
    status: ITaxYearContributionDetailsDtoStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof ITaxYearContributionDetailsDto
     */
    total_after_update: number;
}

/**
* @export
* @enum {string}
*/
export enum ITaxYearContributionDetailsDtoStatusEnum {
    VALID = 'VALID',
    EXCEEDS = 'EXCEEDS'
}


/**
 * Check if a given object implements the ITaxYearContributionDetailsDto interface.
 */
export function instanceOfITaxYearContributionDetailsDto(value: object): value is ITaxYearContributionDetailsDto {
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('total_after_update' in value) || value['total_after_update'] === undefined) return false;
    return true;
}

export function ITaxYearContributionDetailsDtoFromJSON(json: any): ITaxYearContributionDetailsDto {
    return ITaxYearContributionDetailsDtoFromJSONTyped(json, false);
}

export function ITaxYearContributionDetailsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ITaxYearContributionDetailsDto {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'],
        'total_after_update': json['total_after_update'],
    };
}

export function ITaxYearContributionDetailsDtoToJSON(json: any): ITaxYearContributionDetailsDto {
    return ITaxYearContributionDetailsDtoToJSONTyped(json, false);
}

export function ITaxYearContributionDetailsDtoToJSONTyped(value?: ITaxYearContributionDetailsDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': value['status'],
        'total_after_update': value['total_after_update'],
    };
}

